import { createSlice } from "@reduxjs/toolkit";

export const accountSlice = createSlice({
  name: "accountSlice",
  initialState: {
    account: {},
  },
  reducers: {
    accountLogin: (state, action) => {},
    accountLoginSuccess: (state, action) => {
      state.account = action.payload;
    },
    changePassword: (state, action) => {},
  },
});
export const { accountLogin, accountLoginSuccess,changePassword } = accountSlice.actions;
export default accountSlice.reducer;
